import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class TranslateInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body) {
          const translateService = this.injector.get(TranslateService);
          const lang = translateService.currentLang;
          const newBody = this.addTranslatedText(event.body, lang);
          return event.clone({ body: newBody });
        }
        return event;
      })
    );
  }

  private addTranslatedText(obj: any, lang: string): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.addTranslatedText(item, lang));
    } else if (obj !== null && typeof obj === 'object') {
      if (Array.isArray(obj.translates)) {
        const tr = obj.translates.find((t: any) => t.lang === lang);
        obj.translatedText = tr ? tr.text : null;
      }
      Object.keys(obj).forEach(key => {
        obj[key] = this.addTranslatedText(obj[key], lang);
      });
      return obj;
    }
    return obj;
  }
}
